import { RESET as RESET_ADDONS, SELECT_ADDON_SUCCESS } from '../actions/addons'
import {
  DISMISS_ERROR,
  FETCH_CART_DETAILS_FAILURE,
  FETCH_CART_DETAILS_SUCCESS,
  FETCH_CART_ITEMS_FAILURE,
  FETCH_CART_ITEMS_SUCCESS,
  FETCH_CART_REQUEST,
  FOCUS_POSITION
} from '../actions/cart'
import { PAY_NOW_SUCCESS } from '../actions/checkout'
import { LOGIN_SUCCESS } from '../actions/login'
import { LOGOUT_SUCCESS } from '../actions/logout'
import {
  RESET as RESET_PACKAGES,
  SELECT_PACKAGE_SUCCESS
} from '../actions/packages'

const INITIAL_STATE = {
  isReady: false,
  isDetailsReady: false,
  isItemsReady: false,
  hasError: false,
  errorMessage: '',
  reference: '',
  items: [],
  total: 0,
  payNow: 0,
  freeTrial: false,
  focusedPosition: -1
}

const cartReducer = (state = INITIAL_STATE, action) => {
  switch(action.type) {
    case FETCH_CART_REQUEST:
      return {
        ...state,
        isReady: false,
        isDetailsReady: false,
        isItemsReady: false,
        hasError: false,
        errorMessage: ''
      }
    case FETCH_CART_DETAILS_SUCCESS:
      const newState = {
        ...state,
        isReady: state.isItemsReady,
        isDetailsReady: true,
        hasError: false,
        errorMessage: '',
        total: action.payload.total,
        payNow: action.payload.payNow,
        freeTrial: action.payload.freeTrial
      }
      if (action.payload.freeTrial) {
        newState.freeTrialType = action.payload.freeTrialType
        newState.freeTrialLength = action.payload.freeTrialLength
      }
      return newState
    case FETCH_CART_ITEMS_SUCCESS:
      return {
        ...state,
        isReady: state.isDetailsReady,
        isItemsReady: true,
        hasError: false,
        errorMessage: '',
        items: action.payload.items
      }
    case FETCH_CART_DETAILS_FAILURE:
      return {
        ...state,
        isReady: true,
        hasError: true,
        errorMessage: action.payload instanceof Error && action.payload.message !== '' ? action.payload.message : 'An error occurred while trying to load cart summary'
      }
    case FETCH_CART_ITEMS_FAILURE:
      return {
        ...state,
        isReady: true,
        hasError: true,
        errorMessage: action.payload instanceof Error && action.payload.message !== '' ? action.payload.message : 'An error occurred while trying to load cart items'
      }
    case FOCUS_POSITION:
      return {
        ...state,
        focusedPosition: action.payload.position
      }
    case SELECT_PACKAGE_SUCCESS:
      return {
        ...state,
        isReady: false,
        isDetailsReady: false,
        isItemsReady: false,
        items: [],
        reference: action.payload.cart.reference
      }
    case SELECT_ADDON_SUCCESS:
      return {
        ...state,
        isReady: false,
        isDetailsReady: false,
        isItemsReady: false,
        items: [],
        reference: action.payload.response.reference,
      }

    case LOGIN_SUCCESS:
    case LOGOUT_SUCCESS:
    case DISMISS_ERROR:
    case RESET_ADDONS:
    case RESET_PACKAGES:
      return {
        ...INITIAL_STATE
      }

    case PAY_NOW_SUCCESS:
      return {
        ...state,
        reference: '',
        items: [],
        total: 0,
        payNow: 0
      }

    default:
      return state
  }
}

export default cartReducer
